import { Col, Row } from "react-bootstrap";

import { Breadcrumb, Layout, Menu, theme } from "antd";
import K12Logo from "../images/k12.png";
import { IS_K12 , IS_DEMO_K12} from "utils/customerBasedConfigs";
const { Header, Content, Footer } = Layout;
const isK12 = IS_K12;
const isDemoK12= IS_DEMO_K12;
function AuthScreens({ component }) {
  return (
    <div>
      <Header
        style={{
          position: "sticky",
          background: "rgb(227 227 227)",
          top: 0,
          height: "74px",
          zIndex: 1,
          width: "100%",
          display: "flex",
          alignItems: "center",
          justifyContent: isDemoK12 ? "space-between" : "flex-start"
        }}
      >
        <div className="demo-logo" >  {/* style={{ position: "fixed", top: "-7px" }}> */}
          <img style={{height: "100%",
    width: isK12 ? "63%" : "100%",
    maxWidth: "300px",
    padding: "2px 5px"}}src={"/images/client_logo.png"}></img>
        </div>
      {/* RIGHT LOGO (only if isDemoK12) */}
        {isDemoK12 && (
          <div className="demo-logo">
            <img
              src="/images/k12.png"  
              style={{
                height: "100%",
               width: isK12 ? "63%" : "100%",
                maxWidth: "300px",
                padding: "2px 5px"
              }}
              alt="k12 logo"
            />
          </div>
        )}
      </Header>
      <Row align={"middle"} style={{ height: "80vh" , display:"flex",justifyContent:"center" , alignItems: "center", marginTop : "-4rem"}}>
        <Col style={{width:"28%"}} span={24}>{component}</Col>
      </Row>
    </div>
  );
}

export default AuthScreens;
